import React from 'react';
import Services from '../components/home/Services';
import Guarantee from '../components/home/Guarantee';
import FinalCTA from '../components/home/FinalCTA';

const ServicesPage: React.FC = () => {
  return (
    <main className="pt-20">
      <div className="bg-brand-navy py-24 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Our Cleaning Services</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Professional, reliable, and thorough cleaning solutions for every home in Jersey City and Hoboken.
          </p>
        </div>
      </div>
      <Services />
      <div className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <img 
                src="https://public.youware.com/users-website-assets/prod/a4050641-efb8-40ce-9a0d-1ede7709fa59/f01083853048409c8155da90df24e85f.jpg" 
                alt="Professional Cleaning" 
                className="rounded-[3rem] shadow-premium"
              />
            </div>
            <div className="space-y-8">
              <h2 className="text-3xl md:text-5xl font-black text-brand-navy">The CleanHouse NJ Standard</h2>
              <p className="text-lg text-brand-navy/70 leading-relaxed">
                We don't just clean; we restore your home to its best state. Our teams follow a rigorous 50-point checklist 
                to ensure every corner, surface, and hidden spot is addressed.
              </p>
              <ul className="space-y-4">
                {[
                  "HEPA-filter vacuums for superior air quality",
                  "Microfiber technology to trap 99% of dust",
                  "Eco-friendly and pet-safe cleaning agents",
                  "Systematic room-by-room approach",
                  "Final quality inspection on every visit"
                ].map((item, i) => (
                  <li key={i} className="flex items-center space-x-3 font-bold text-brand-navy">
                    <div className="w-6 h-6 bg-brand-blue text-white rounded-full flex items-center justify-center text-[10px]">✓</div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Guarantee />
      <FinalCTA />
    </main>
  );
};

export default ServicesPage;
